import { Link } from "react-router-dom";

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="bg-[#2C2C2C] text-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h3 className="text-xl font-medium mb-6">FluxPoint Digital LLC</h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-8 max-w-md">
              Digital media, software development, and asset management operations
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-[#2C2C2C] transition-all cursor-pointer"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-[#2C2C2C] transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-[#2C2C2C] transition-all cursor-pointer"
              >
                <i className="ri-github-line text-lg"></i>
              </a>
              <a
                href="mailto:admin@fluxpointdigital.org"
                className="w-10 h-10 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-[#2C2C2C] transition-all cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold text-gray-500 tracking-widest uppercase mb-5">
              QUICK LINKS
            </p>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={scrollToTop}
                  className="text-sm text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('capabilities')}
                  className="text-sm text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Capabilities
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('projects')}
                  className="text-sm text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Projects
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-semibold text-gray-500 tracking-widest uppercase mb-5">
              CONTACT
            </p>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:admin@fluxpointdigital.org"
                  className="text-sm text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  admin@fluxpointdigital.org
                </a>
              </li>
              <li>
                <a
                  href="tel:+15551234567"
                  className="text-sm text-gray-400 hover:text-white hover:underline transition-colors cursor-pointer"
                >
                  +1 (909) 452-2539
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-8 lg:px-16 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-xs text-gray-400">
                © 2026 FluxPoint Digital LLC. All rights reserved.
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Registered in California, USA.
              </p>
            </div>
            <div className="flex space-x-6">
              <Link
                to="/privacy-policy"
                className="text-xs text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-xs text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Terms of Service
              </Link>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}